import { Modal, Spin, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text, Title } = Typography;

/**
 * The blocking "please wait" dialog shown while the advisor's final submit runs.
 *
 * That press is no longer one call. It chains a save, a document delivery that polls BMO until
 * every file is confirmed, and the point-of-no-return submit (see `FormShell.submitApplication`)
 * — tens of seconds on a real application, and the middle link alone may wait up to five minutes
 * (`deliverAdditionalDocuments`'s POLL_BUDGET_MS). A button spinner is not enough cover for that:
 * the page underneath still reads as interactive, and an advisor who clicks away or closes the
 * tab mid-chain can leave documents delivered against an application BMO was never told to
 * submit.
 *
 * So it is a modal, and deliberately an inescapable one — no ×, no mask click, no Escape, no
 * footer. There is no "not now" here: the chain is already in flight and nothing the advisor
 * could press would call it back. It closes when the chain settles, either onto the Thank You
 * card or back onto the step with an error toast explaining what to retry.
 *
 * Sibling of `OptionRedirectModal` at the foot of FormShell.tsx, which is non-dismissible for
 * the same reason and is where the prop set comes from.
 */
export function ProcessingModal() {
  const { t } = useTranslation();
  return (
    <Modal
      open
      closable={false}
      maskClosable={false}
      keyboard={false}
      footer={null}
      title={null}
      centered
      width={420}
      // The copy IS the content, so the dialog is labelled by its own heading rather than by a
      // title bar it does not have.
      aria-labelledby="processing-modal-title"
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 18,
          padding: '20px 8px 12px',
          textAlign: 'center',
        }}
      >
        <Title id="processing-modal-title" level={4} style={{ margin: 0, color: '#111827' }}>
          {t('formRenderer.processing.title')}
        </Title>
        <Spin size="large" />
        <Text style={{ fontSize: 14, color: '#374151' }}>
          {t('formRenderer.processing.subtitle')}
        </Text>
      </div>
    </Modal>
  );
}
